import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgMobileProfile = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 13,
	height: 15,
	viewBox: "0 0 13 15",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		d: "M9.14801 3.26628C9.14801 4.73904 7.9541 5.93294 6.48134 5.93294C5.00858 5.93294 3.81468 4.73904 3.81468 3.26628C3.81468 1.79352 5.00858 0.599609 6.48134 0.599609C7.9541 0.599609 9.14801 1.79352 9.14801 3.26628Z",
		stroke: "#5583F6",
		strokeWidth: 1.2
	}), /* @__PURE__ */ _jsx("path", {
		d: "M11.148 13.9329C11.8844 13.9329 12.4961 13.3288 12.3338 12.6105C12.0859 11.5132 11.5321 10.4984 10.724 9.6903C9.59877 8.56508 8.07264 7.93294 6.48134 7.93294C4.89005 7.93294 3.36392 8.56508 2.2387 9.6903C1.43062 10.4984 0.876834 11.5132 0.628869 12.6105C0.466553 13.3288 1.0783 13.9329 1.81468 13.9329H11.148Z",
		stroke: "#5583F6",
		strokeWidth: 1.2
	})]
});
export default SvgMobileProfile;
